import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { RecoilRoot } from 'recoil';
import { RecoilExternalSetter } from './atoms/recoilOutside';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <RecoilExternalSetter />
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
